import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Inbox } from 'lucide-react';
import { format } from 'date-fns';
import { api } from '../api/client';
import { Badge } from '../components/ui/Badge';
import { EmptyState } from '../components/ui/EmptyState';
import { ETAPA_MAP } from '../lib/constants';
import { parseDate, formatPeriodo } from '../lib/dates';

export function MinhasDemandasPage() {
  const nav = useNavigate();
  const [demandas, setDemandas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [incluirCanceladas, setIncluirCanceladas] = useState(
    () => localStorage.getItem('minhas.incluirCanceladas') === 'true'
  );

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ minhas: 'true' });
    if (incluirCanceladas) params.set('incluir_canceladas', 'true');
    api.get(`/demandas?${params.toString()}`).then((r) => setDemandas(r.demandas)).finally(() => setLoading(false));
  }, [incluirCanceladas]);
  useEffect(() => { localStorage.setItem('minhas.incluirCanceladas', String(incluirCanceladas)); }, [incluirCanceladas]);

  if (loading) return <div className="loader-full"><span className="spinner" /></div>;

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Minhas demandas</h1>
          <p className="page-subtitle">Acompanhe as demandas que você solicitou.</p>
        </div>
        <div className="row-wrap" style={{ gap: 12 }}>
          <label className="row" style={{ gap: 6, fontSize: 13, color: 'var(--c-text-muted)', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={incluirCanceladas}
              onChange={(e) => setIncluirCanceladas(e.target.checked)}
            />
            Mostrar canceladas
          </label>
          <button className="btn btn-primary" onClick={() => nav('/nova-demanda')}>
            <Plus size={16} /> Nova Demanda
          </button>
        </div>
      </div>

      {demandas.length === 0 ? (
        <div className="card"><div className="card-body">
          <EmptyState
            icon={Inbox}
            title="Você ainda não enviou demandas"
            description="Clique em 'Nova Demanda' para criar sua primeira solicitação de comunicação."
            action={<button className="btn btn-primary" onClick={() => nav('/nova-demanda')}><Plus size={16} /> Nova Demanda</button>}
          />
        </div></div>
      ) : (
        <div className="card"><div className="card-body" style={{ padding: 0 }}>
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Título</th>
                  <th>Etapa</th>
                  <th>Aprovação</th>
                  <th>Data da ação</th>
                  <th>Atualizada</th>
                </tr>
              </thead>
              <tbody>
                {demandas.map((d) => (
                  <tr key={d.id} style={{ cursor: 'pointer' }} onClick={() => nav(`/demandas/${d.codigo}`)}>
                    <td><strong>{d.titulo}</strong>{d.nao_lidas > 0 && <Badge color="primary" style={{ marginLeft: 6 }}>{d.nao_lidas} novas</Badge>}</td>
                    <td><Badge color={ETAPA_MAP[d.etapa]?.color}>{ETAPA_MAP[d.etapa]?.label}</Badge></td>
                    <td>
                      {d.aprovacao === 'aprovado' && <Badge color="success">Aprovado</Badge>}
                      {d.aprovacao === 'reprovado' && <Badge color="danger">Reprovado</Badge>}
                      {d.aprovacao === 'pendente' && <Badge>Pendente</Badge>}
                    </td>
                    <td>{d.data_acao ? formatPeriodo(d.data_acao, d.data_acao_fim) : <span className="muted">—</span>}</td>
                    <td className="text-xs muted">{format(new Date(d.updated_at), 'dd/MM/yyyy HH:mm')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div></div>
      )}
    </div>
  );
}
